import { Injectable } from '@angular/core';
import { PeriodsService } from './periods.service';
import { OrdersChart, OrdersChartData } from '../data/orders-chart';
import { EntityService } from '../../shared/services/entity.service';
import { API_URLS } from '../../shared/API_URLS';

@Injectable()
export class OrdersChartService extends OrdersChartData {

  private year = [
    '2012',
    '2013',
    '2014',
    '2015',
    '2016',
    '2017',
    '2018',
  ];

  private data = { };

  constructor(private period: PeriodsService, private entity: EntityService) {
    super();
    this.data = {
      week: this.getDataForWeekPeriod(),
      month: this.getDataForMonthPeriod(),
      year: this.getDataForYearPeriod(),
    };
  }

  private getDataForWeekPeriod(): OrdersChart {
    return {
      chartLabel: this.getDataLabels(42, this.period.getWeeks()),
      linesData: [
        // [
        //   184, 267, 326, 366, 389, 399,
        //   392, 371, 340, 304, 265, 227,
        //   191, 158, 130, 108, 95, 91, 97,
        //   109, 125, 144, 166, 189, 212,
        //   236, 259, 280, 300, 316, 329,
        //   338, 342, 339, 329, 312, 288,
        //   258, 221, 178, 128, 71,
        // ],
        // [
        //   158, 178, 193, 205, 212, 213,
        //   204, 190, 180, 173, 168, 164,
        //   162, 160, 159, 158, 159, 166,
        //   179, 195, 215, 236, 257, 276,
        //   292, 301, 304, 303, 300, 293,
        //   284, 273, 262, 251, 241, 234,
        //   232, 232, 232, 232, 232, 232,
        // ],
        // [
        //   58, 137, 202, 251, 288, 312,
        //   323, 324, 311, 288, 257, 222,
        //   187, 154, 124, 100, 81, 68, 61,
        //   58, 61, 69, 80, 96, 115, 137,
        //   161, 186, 210, 233, 254, 271,
        //   284, 293, 297, 297, 297, 297,
        //   297, 297, 297, 297, 297,
        // ],
      ],
    };
  }

  private getDataForMonthPeriod(): OrdersChart {
    return {
      chartLabel: this.getDataLabels(47, this.period.getMonths()),
      linesData: [
        190, 269, 327, 366, 389, 398,
        396, 387, 375, 359, 343, 327,
        312, 298, 286, 276, 270, 268,
        265, 258, 247, 234, 220, 204,
        188, 172, 157, 142, 128, 116,
        106, 99, 95, 94, 92, 89, 84,
        77, 69, 60, 49, 36, 22,
      ],
    };
  }

  private getDataForYearPeriod(): OrdersChart {
    return {
      chartLabel: this.getDataLabels(42, this.year),
      linesData: [
        190, 269, 327, 366, 389, 398,
        396, 387, 375, 359, 343, 327,
        312, 298, 286, 276, 270, 268,
        265, 258, 247, 234, 220, 204,
        188, 172, 157, 142, 128, 116,
        106, 99, 95, 94, 92, 89, 84,
        77, 69, 60, 49, 36, 22,

      ],
    };
  }

  getDataLabels(nPoints: number, labelsArray: string[]): string[] {
    const labelsArrayLength = labelsArray.length;
    const step = Math.round(nPoints / labelsArrayLength);

    return Array.from(Array(nPoints)).map((item, index) => {
      const dataIndex = Math.round(index / step);

      return index % step === 0 ? labelsArray[dataIndex] : '';
    });
  }

  getOrdersChartData(period: string): OrdersChart {
    // console.log('period', period)
    // this.entity.getData(API_URLS.Report.getOrder+ '?duration='+ period).then(
    //   res=>{
    //     res.subscribe(a=>{
    //       // console.log('aaaaaaaaaaaaaaaaaaa',a);
    //      return this.data[period] = a
    //     })
    //   }
    // )
    // console.log('this.data[period]', this.data[period])
    return this.data[period];
  }
}
